import React, { Component } from 'react';
import { addBonusDialogueStyles } from '../styles';

import {
    Modal,
    Card,
    CardHeader,
    IconButton,
    Typography,
    CardContent,
    Grid,
    Button,
    WithStyles,
    withStyles
} from "@material-ui/core";

interface BonusInfoPopupProps extends WithStyles<typeof addBonusDialogueStyles> {
    isDialogOpen: boolean;
}
 
interface BonusInfoPopupState {
    isDialogOpen: boolean;
}
 
class BonusInfoPopup extends Component<BonusInfoPopupProps, BonusInfoPopupState> {
    constructor(props: BonusInfoPopupProps) {
        super(props);
        this.state = { 
            isDialogOpen: true
         };
    }


    render() { 
        const {  classes  } = this.props;
        return ( 
            <Modal
            className={[
              classes.fontSizeLG,
              classes.fontWeight500,
              classes.modal,
            ].join(" ")}
            open={this.state.isDialogOpen}
          >
            <div >
              <Card >
                <CardHeader
                  className={classes.modalHeader}
                  action={
                    <IconButton
                      aria-label="settings"
                    >
                    </IconButton>
                  }
                  title={
                    <Typography
                      align="center"
                      className={[classes.fontWeight500, classes.fontSizeLG].join(
                        " "
                      )}
                    >
                      Add Bonus Content
                    </Typography>
                  }
                />
                <CardContent>
                  <Grid
                    container
                    spacing={8}
                    alignItems="center"
                  > 
                  <Grid container direction="row" justify="center" alignItems="center" className={classes.mxWidth500}>
                        <Grid>
                            <img
                            src="/assets/svg/license_expired.svg"
                            alt="Bonus Info"
                            />
                    </Grid>
                    </Grid>
                      <Grid
                        container                        
                        className={classes.mb1x}
                        alignItems="center"
                      >
                        <Typography
                          variant="body1"
                          gutterBottom
                          className={classes.fontSizeMD}
                        >
                        Additonal content for students scoring the desires proficiency
                        </Typography>
                      </Grid>
                    </Grid>
                  <Grid item container  alignItems="center">
                    <Button
                      variant="contained"
                      color="primary"
                    >
                      Ok, Got it!
                    </Button>
                  </Grid>
                </CardContent>
              </Card>
            </div>
           </Modal>
         );
    }
}

 // @ts-ignore
export default withStyles(addBonusDialogueStyles)(BonusInfoPopup);